var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fd-button-group"},_vm._l((_vm.config.values),function(button){return _c('button-view',{key:button.value || button.key,attrs:{"config":button,"selected":_vm.config.mode == 'radio' && button.value == _vm.value
			||
			_vm.config.mode == 'check' && _vm.value[button.key]},on:{"click":function($event){_vm.handleClick(button)}}})}))}
var staticRenderFns = []

export { render, staticRenderFns }